import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { supabaseDev } from "../supabaseDevClient/supabaseDevClient";
import { CircularProgress, Box } from "@mui/material";

const ProtectedLayout = () => {
  const [loading, setLoading] = useState(true);
  const [session, setSession] = useState(null);

  useEffect(() => {
    const fetchSession = async () => {
      const { data } = await supabaseDev.auth.getSession();
      setSession(data?.session || null);
      setLoading(false);
    };

    fetchSession();

    const { data: listener } = supabaseDev.auth.onAuthStateChange(
      (_event, session) => {
        setSession(session);
      }
    );

    return () => {
      listener.subscription.unsubscribe();
    };
  }, []);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress color="primary" />
      </Box>
    );
  }

  if (!session) {
    return <Navigate to="/signin" replace />;
  }

  return <Outlet />; // renders nested protected routes
};

export default ProtectedLayout;
